/**
 * Wire contract for the waiting-assignment queue (`GET /yard/view/waiting-assets`), shared by
 * Neutron's query DTO and its callers.
 */

export enum WaitingAssetsSortField {
  CreateDateTime = 'createDateTime',
  LastChangedDateTime = 'lastChangedDateTime',
  AppointmentStart = 'appointmentStart'
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Lookback applied to the visit stream when the request names no window. */
export const WAITING_ASSETS_DEFAULT_WINDOW_DAYS = 7;

/**
 * Largest lookback a request may name. This bounds the input so the computed cutoff stays a valid
 * date; it is not a policy cap on the window. Past roughly 1e8 days the date is invalid, its ISO
 * form is null, and a falsy cutoff is dropped — which removes the window altogether.
 */
export const WAITING_ASSETS_MAX_ACCEPTED_WINDOW_DAYS = 365;
